import { Particle, type ParticleOptions } from "../Particle";
import { MovesLiquid } from "../behaviors/MovesLiquid";
import { PhaseChange } from "../behaviors/PhaseChange";
import { SpreadFire } from "../behaviors/SpreadFire";
import { HeatTransfer } from "../behaviors/HeatTransfer";
import { Stone } from "./Stone";
import { adjustColor } from "../../utils/color";

export class Lava extends Particle {
    static colors = [
        0x2A0A0A, // Crust (Black-Red)
        0x500000, // Dark Magma
        0xCF1020, // Lava Red
        0xFF4500, // OrangeRed
        0xFF8C00  // DarkOrange
    ];

    constructor(options: Partial<ParticleOptions> = {}) {
        const baseColor = Lava.colors[Math.floor(Math.random() * Lava.colors.length)] ?? 0xCF1020;
        super({
            name: "Lava",
            color: adjustColor(baseColor, 10),
            behaviors: [
                new MovesLiquid(0.8), // 高粘度
                new SpreadFire(0.2), // 岩浆很容易点燃东西
                new HeatTransfer(0.002), // 降低热传递速率，使其冷却更慢
                new PhaseChange([
                    { temp: 800, type: 'below', factory: () => new Stone({ temperature: 780 }), probability: 0.1 } // 冷却变成石头，增加概率延迟
                ]),
                // 移除 TemperatureNormalization，使其保持高温
            ],
            props: { isLiquid: true, isFlammable: false, thermalConductivity: 0.3 }, // 降低热导率 (岩石导热较差)
            temperature: 1200, // 初始高温
            minTemp: 20,
            maxTemp: 5000,
            ...options
        });
    }
}
